import React from "react";
import { Link } from "react-router-dom";
import { WebJestersSiteLink } from "./WebJestersSiteLink";

export const PublicFooter = ({ prefix }) => (
    <footer data-testid={`${prefix}-footer`} className="absolute z-10 bottom-6 inset-x-0 px-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center text-[11px] text-zinc-600 tracking-wide">
        <span>© <WebJestersSiteLink testid={`${prefix}-webjesters-link`} /> · Operational portal for service businesses</span>
        <Link to="/privacy" data-testid={`${prefix}-privacy-link`} className="hover:text-zinc-300 transition-colors">Privacy</Link>
        <Link to="/terms" data-testid={`${prefix}-terms-link`} className="hover:text-zinc-300 transition-colors">Terms</Link>
    </footer>
);